import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// ============================================
// Parent Web - Main App Component
// ============================================
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './providers/AuthProvider';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useChildren } from '@pc/hooks';
// Pages (lazy loaded)
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const DashboardPage = React.lazy(() => import('./pages/DashboardPage'));
const ChildrenPage = React.lazy(() => import('./pages/ChildrenPage'));
const ChildDetailPage = React.lazy(() => import('./pages/ChildDetailPage'));
const AppsPage = React.lazy(() => import('./pages/AppsPage'));
const StatsPage = React.lazy(() => import('./pages/StatsPage'));
const SettingsPage = React.lazy(() => import('./pages/SettingsPage'));
const OnboardingPage = React.lazy(() => import('./pages/OnboardingPage'));
function PageLoader() {
    return (_jsx("div", { className: "flex items-center justify-center min-h-screen", children: _jsx("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" }) }));
}
// ─── Onboarding Guard ─────────────────────────────────────────────────────────
function OnboardingGuard({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    const { data: childrenData = [], isLoading: childrenLoading } = useChildren();
    const location = useLocation();
    if (isLoading || childrenLoading)
        return _jsx(PageLoader, {});
    if (!isAuthenticated)
        return _jsx(_Fragment, { children: children });
    if (location.pathname.startsWith('/onboarding'))
        return _jsx(_Fragment, { children: children });
    const done = localStorage.getItem('onboarding_done');
    if (!done && childrenData.length === 0) {
        return _jsx(Navigate, { to: "/onboarding", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
// ─── App ──────────────────────────────────────────────────────────────────────
export function App() {
    return (_jsx(AuthProvider, { children: _jsx(React.Suspense, { fallback: _jsx(PageLoader, {}), children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/auth/callback", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/onboarding", element: _jsx(ProtectedRoute, { children: _jsx(OnboardingPage, {}) }) }), _jsxs(Route, { path: "/", element: _jsx(ProtectedRoute, { children: _jsx(OnboardingGuard, { children: _jsx(Layout, {}) }) }), children: [_jsx(Route, { index: true, element: _jsx(Navigate, { to: "/dashboard", replace: true }) }), _jsx(Route, { path: "dashboard", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "children", element: _jsx(ChildrenPage, {}) }), _jsx(Route, { path: "children/:childId", element: _jsx(ChildDetailPage, {}) }), _jsx(Route, { path: "apps", element: _jsx(AppsPage, {}) }), _jsx(Route, { path: "stats", element: _jsx(StatsPage, {}) }), _jsx(Route, { path: "settings", element: _jsx(SettingsPage, {}) })] }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }) }));
}
//# sourceMappingURL=App.js.map